import React, { Component } from "react";
import "./App.css";
import { Container, Row, Col } from "reactstrap";
import Header from "./Header";
import Footer from "./Footer";
import MobileDetect from "mobile-detect";

class Team extends Component {
  render() {
    const md = new MobileDetect(window.navigator.userAgent);
    let textClassName;
    if (md.mobile() || md.tablet() || md.phone()) {
      textClassName = "team-profile-mobile";
    }
    return (
      <div className="TeamApp">
        <Header white />
        <div className="team-container">
          <div style={{ paddingTop: "100px" }}>
            <Container>
              <Row noGutters>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-pa">
                    <img className="team-profile" alt="Paul Ahlstrom" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/paulbahlstrom/">
                          Paul Ahlstrom
                          <br />
                          <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-tc">
                    <img className="team-profile" alt="Timothy Cottrell" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/timothy-cottrell-b43a9822/">
                          Timothy Cottrell <br />
                          <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-rm">
                    <img className="team-profile" alt="Rob McMillen" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/rob-mcmillen-b940846/">
                          Rob McMillen
                          <br />
                          <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-he">
                    <img className="team-profile" alt="Homero Elizondo" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/homero-elizondo-giacoman-4a9592/">
                          Homero Elizondo <br />
                          <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-bc">
                    <img className="team-profile" alt="Brian Cummings" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/brian-cummings-8464a71/">
                          Brian Cummings <br /> <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-ns">
                    <img className="team-profile" alt="Nelly Salas" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/nelly-salas-02b47b40/">
                          Nelly Salas <br />
                          <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-rg">
                    <img className="team-profile" alt="Roy Glasberg" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/roygevaglasberg/">
                          Roy Glasberg <br />
                          <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="team-profile-container team-profile-container-rl">
                    <img className="team-profile" alt="Robb Lifferth" />
                    <div className={textClassName}>
                      <span>
                        <a href="https://www.linkedin.com/in/robblifferth/">
                          Robb Lifferth <br />
                          <i className="fa fa-linkedin" />
                        </a>
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/Team.js